import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const HajjAndUmrahBookings = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Hajj & Umrah Bookings - Polani Travels"
        fallbackDescription="Hassle-free Hajj and Umrah bookings with Polani Travels. Trusted, experienced, and professional spiritual travel services for your peace of mind."
        fallbackKeywords="Hajj bookings, Umrah bookings, Hajj packages, Umrah packages, spiritual travel, Makkah, Madinah, Pakistan, Polani Travels"
        fallbackOgTitle="Hajj & Umrah Bookings - Polani Travels"
        fallbackOgDescription="Your trusted partner for Hajj and Umrah travel. Government-approved packages, visa support, and complete travel arrangements."
        fallbackCanonicalUrl="https://poliflytravels.com/hajj-and-umrah-bookings/"
      />

      <CommonBanner
        heading="Hajj & Umrah Bookings"
        img={ImageConstants.visabanner}
        pagination="Hajj & Umrah Bookings"
      />

      <section className="umrah-detailed-section pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Polani Travels – Your Trusted Partner for Umrah Packages from Pakistan</h2>
                <h4 className="mb-3">Plan Your Spiritual Journey with Comfort, Clarity, and Care</h4>
                <p>
                  At Polani Travels, we understand that Umrah is not just a journey — it's a deeply spiritual experience, cherished by every Muslim. Our thoughtfully designed Umrah packages are created to offer you a peaceful, well-organized, and spiritually fulfilling trip — free from stress and uncertainty.
                </p>
                <p>
                  With years of experience and a dedicated team, Polani Travels proudly provides customized and complete Umrah services for individuals, families, and groups across Pakistan. Whether it's your first Umrah or a return visit, we ensure every detail is handled so you can focus solely on your ibadah and reflection.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Why Choose Polani Travels for Your Umrah Journey?</h3>
                  <p>
                    When you embark on such a sacred mission, choosing the right travel partner is essential. At Polani Travels, we combine sincerity with professionalism — ensuring your comfort, safety, and peace of mind throughout the journey.
                  </p>
                  <ul className="benefits-list">
                    <li><strong>Complete Visa Assistance:</strong> Our expert team takes care of the entire Umrah visa process — from documentation to timely submissions — so you don't face any delays or complications.</li>
                    <li><strong>Flight Bookings & Travel Arrangements:</strong> We arrange return flights from all major cities in Pakistan with reliable airlines. Travel schedules are flexible, and we accommodate your preferred dates and group sizes.</li>
                    <li><strong>Comfortable Accommodations Near Haram:</strong> Stay close to Masjid al-Haram in Makkah and Masjid an-Nabawi in Madinah. Whether you prefer budget-friendly or luxury hotels, we offer multiple options to suit your needs.</li>
                    <li><strong>Transport Within Saudi Arabia:</strong> Enjoy smooth travel with organized airport pickups, transfers between Jeddah, Makkah, and Madinah, and local transportation for Ziyarat and other needs.</li>
                    <li><strong>24/7 Ground Support:</strong> Our support staff is available around the clock during your stay. From check-ins to on-ground assistance, we are always just a phone call away to help with anything you need.</li>
                  </ul>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">Flexible Umrah Packages for Every Type of Traveler</h3>
                  <p>
                    At Polani Travels, we know that every pilgrim's journey is unique. That's why we offer packages tailored for various preferences:
                  </p>
                  <ul className="benefits-list">
                    <li><strong>Economy Umrah Packages</strong> – Affordable and essential services</li>
                    <li><strong>Standard Packages</strong> – Comfortable and balanced arrangements</li>
                    <li><strong>VIP Packages</strong> – Luxury hotels, private transport, and personalized service</li>
                    <li><strong>Family Packages</strong> – Safe, convenient, and family-friendly options</li>
                    <li><strong>Custom Packages</strong> – Choose your own travel dates, hotel class, and services</li>
                  </ul>
                  <p>
                    Whether you're planning to travel in Ramadan, school holidays, or during the off-season — we'll help you pick the right option for your budget and timing.
                  </p>
                </div>
              
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Trust, Transparency & Taqwa – The Polani Promise</h3>
                  <p>
                    With Polani Travels, you get clear pricing, no hidden charges, and complete honesty. Every package is discussed transparently, and we strictly follow religious, legal, and Saudi travel guidelines. We keep you updated on all relevant changes from the authorities to ensure your journey is smooth and compliant.
                  </p>
                </div> </div>
           
          </div>
          <div className='row'>
          
            <div className='col-lg-12'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Book Your Umrah Journey Today</h3>
                  <p>
                    Take the first step toward fulfilling this blessed act of worship with a team that truly cares. Polani Travels has earned the trust of thousands of pilgrims through our honesty, dedication, and deep respect for the sacred nature of this journey.
                  </p>
                  <p className="mt-3 mb-5">
                    <strong>📞 Contact our Umrah consultants today for a free consultation or to customize your Umrah package. We are here to serve you — from your first question to your safe return home.</strong>
                  </p>
                  <p className="mt-3 mb-5"><strong>Polani Travels – Honored to Serve You on Your Sacred Journey.</strong></p>
               
                </div>
            </div>
          </div>
          
        </div>
      </section>

    
    </>
  );
};

export default HajjAndUmrahBookings;